module.exports = (__webpack_require__(15))(10);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/defineProperty.js from dll-reference vendor_library
// module id = 96
// module chunks = 0